// AuthLayout — wrapper centrado para pantallas de Login / ForgotPassword
// / ResetPassword / Signup (B3, B4). Sin sidebar, sin header productivo.
// Logo Gonix arriba + card centrada + slot.
//
// Sub-decisión Sprint 2 B3: estética estándar de auth screens, fuera
// del shell de la app productiva. El usuario aterriza acá pre-sesión
// (o post-recovery) y vuelve al shell solo cuando hay sesión válida.

import type { ReactNode } from "react";
import logoGonixLight from "@/assets/logo-gonix-light.png";
import logoGonixDark from "@/assets/logo-gonix-dark.png";

interface Props {
  title: string;
  /** Copy descriptivo opcional debajo del título. */
  subtitle?: string;
  children: ReactNode;
  /** Footer slot debajo del card (links tipo "¿No tenés cuenta? Registrate"). */
  footer?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer }: Props) {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img
            src={logoGonixLight}
            alt="Gonix"
            className="block dark:hidden h-12 w-auto object-contain"
          />
          <img
            src={logoGonixDark}
            alt="Gonix"
            className="hidden dark:block h-12 w-auto object-contain"
          />
        </div>

        <div className="bg-card rounded-2xl border border-border shadow-sm p-6 md:p-8">
          <h1 className="text-2xl font-semibold mb-1">{title}</h1>
          {subtitle && (
            <p className="text-sm text-muted-foreground mb-6">{subtitle}</p>
          )}
          {!subtitle && <div className="mb-6" />}
          {children}
        </div>

        {footer && (
          <div className="mt-6 text-center text-sm text-muted-foreground">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
